/**
 * Worktree Footer — persistent status bar at the bottom of the viewport.
 *
 * Shows the current worktree name with a distinctive accent color
 * so it's immediately clear which instance this is.
 * Styled to match the Pi TUI footer: dark bar, accent dot, monospace name.
 *
 * Only rendered when VITE_WORKTREE_NAME is set (this worktree only).
 */

import React from 'react';

const WORKTREE_NAME = import.meta.env?.VITE_WORKTREE_NAME ?? '';

export function WorktreeFooter() {
  if (!WORKTREE_NAME) return null;

  // Extract short name: "GEODE-WEB-V3-AI-Scanner" → just use the env var as-is
  // If the env var contains the full path, take the last segment
  const shortName = WORKTREE_NAME.split('/').pop() ?? WORKTREE_NAME;

  return (
    <div
      data-print-hide="true"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        height: '24px',
        padding: '0 12px',
        backgroundColor: '#18181a',
        fontFamily:
          "'SF Mono', 'Cascadia Code', 'Fira Code', Consolas, monospace",
        fontSize: '11px',
        fontWeight: 600,
        letterSpacing: '0.01em',
        borderTop: '1px solid #2a2a2a',
        userSelect: 'none',
        pointerEvents: 'none',
        gap: '6px',
      }}
    >
      <span
        style={{
          display: 'inline-block',
          width: '7px',
          height: '7px',
          borderRadius: '1px',
          backgroundColor: '#FFD600',
          flexShrink: 0,
        }}
      />
      <span style={{ color: '#e8e8e8' }}>{shortName}</span>
    </div>
  );
}
